import {
  collection,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  query,
  orderBy,
} from 'firebase/firestore'
import { db, COLLECTIONS } from '@/lib/firebase'
import type { ProductRequest } from '@/types'

const col = collection(db, COLLECTIONS.productRequests)

export interface SubmitProductRequestInput {
  fullName: string
  email: string
  phone: string
  productName: string
  quantity: number
}

export async function submitProductRequest(
  input: SubmitProductRequestInput
): Promise<string> {
  const docRef = doc(col)
  const id = docRef.id

  const payload: ProductRequest = {
    id,
    fullName: input.fullName.trim(),
    email: input.email.trim().toLowerCase(),
    phone: input.phone.trim(),
    productName: input.productName.trim(),
    quantity: Math.min(999, Math.max(1, Math.floor(input.quantity))),
    createdAt: new Date().toISOString(),
  }

  await setDoc(docRef, payload)
  return id
}

export async function fetchProductRequests(): Promise<ProductRequest[]> {
  const q = query(col, orderBy('createdAt', 'desc'))
  const snap = await getDocs(q)
  return snap.docs.map((d) => d.data() as ProductRequest)
}

export async function deleteProductRequest(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTIONS.productRequests, id))
}
